// extracted by mini-css-extract-plugin
var _1 = "TemplatesSuggestions-module__buttons--jRbjH";
var _2 = "TemplatesSuggestions-module__container--X_sPq";
var _3 = "TemplatesSuggestions-module__description--BlRwK";
var _4 = "TemplatesSuggestions-module__separator--gJuY4";
var _5 = "TemplatesSuggestions-module__separatorText--B8p9F";
var _6 = "TemplatesSuggestions-module__templates--WCpNb";
var _7 = "TemplatesSuggestions-module__title--D5vWM";
export { _1 as "buttons", _2 as "container", _3 as "description", _4 as "separator", _5 as "separatorText", _6 as "templates", _7 as "title" }
